import { Loader2 } from "lucide-react";

/**
 * Full-screen loading state shown while a delete mutation is in flight — the
 * Tailwind equivalent of the legacy screen's Semantic UI `Dimmer` + `Loader`
 * combo (see src/screens/product/productList/ProductList.tsx), copied from
 * `LoadingOverlay`
 * (src/screens/lcaIngredients/ingredientList/components/LoadingOverlay.tsx).
 *
 * `z-[60]`, not `z-50`: this is also rendered while the Register/Edit/Details
 * modals are saving (see their `vm.isSaving` usage). Those modals' `Sheet`
 * overlay+content are `z-50` too, and — being Radix-portaled to the end of
 * `document.body` — win any z-index tie against this plain inline `div` on
 * paint order alone, so an equal z-index left the spinner hidden behind the
 * modal's own dark backdrop.
 */
const LoadingOverlay = () => {
  return (
    <div
      className="tw-fixed tw-inset-0 tw-z-[60] tw-flex tw-items-center tw-justify-center tw-bg-white/75 tw-backdrop-blur-[1px]"
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-rounded-lg tw-border tw-border-primary/20 tw-bg-white tw-px-8 tw-py-5 tw-shadow-md">
        <Loader2 className="tw-h-8 tw-w-8 tw-animate-spin tw-text-primary" />
        <p className="tw-text-sm tw-font-medium tw-text-primary">Loading...</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;
